import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LanguageService } from '../services/language/language.service';

export const authGuard: CanActivateFn = () => {
  const languageService: LanguageService = inject(LanguageService);
  const oauthService: OAuthService = inject(OAuthService);

  if (!oauthService.hasValidAccessToken()) {
    oauthService.customQueryParams = {
      lang: languageService.getCurentLanguage(),
    };
    oauthService.loadDiscoveryDocumentAndLogin().then();
    return false;
  }

  return true;
};

export const authGuardChild: CanActivateChildFn = () => {
  const languageService: LanguageService = inject(LanguageService);
  const oauthService: OAuthService = inject(OAuthService);

  if (!oauthService.hasValidAccessToken()) {
    oauthService.customQueryParams = {
      lang: languageService.getCurentLanguage(),
    };
    oauthService.loadDiscoveryDocumentAndLogin().then();
    return false;
  }

  return true;
};
